import React from 'react';
import './App.scss';
import MainRoutes from './views/Main/MainRoutes.js';
import AdminRoutes from './views/Admin/AdminRoutes';
import mixin from './utils/mixin';
import i18n from 'i18n-js';

function App() {
  mixin.methods.G_init({
    store: null,
    language: 'es',
    translate: (key) => {
      return i18n.t(key);
    }
  });

  return (
    <div className="containter main-containter">
      <MainRoutes />
      <AdminRoutes />
    </div>
  );
}

export default App;